import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import AvailabilityNotificationPopup from './popups/AvailabilityNotificationPopup'
import { selectPlaceData, selectPlaceId, selectPlaceStatus } from './placeSlice'
import useFreshPlaceData from './hooks/useFreshPlaceData'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import useSelectedHash from './hooks/useSelectedHash'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import DetailsPopup from './popups/DetailsPopup'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import htbox1 from 'assets/img/htbox1.png'
import { useEffect, useRef } from 'react'
import { STATUS } from 'utils/constants'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import MagElement from './MagElement'
import RentButton from './RentButton'
import Error from 'components/Error'
import { v7 } from 'uuid'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const MapDetails = () => {
  const [selectedHash, variant, selectHash] = useSelectedHash()

  const { state } = useLocation()
  const placeId = useSelector(selectPlaceId)
  const config = useReduxSelector(selectConfig)
  const status = useSelector(selectPlaceStatus)
  const { warehouses, sizes: allSizes, sizeGroups: allSizesGroups, ...place } = useSelector(selectPlaceData)
  const { placeId: placeIdParams } = useParams()
  const { popup, openPopup } = usePopupState()

  useFreshPlaceData()
  const dispatch = useDispatch()
  const { push, replace } = useHistory()
  const { t } = useTranslation('mapDetails')

  const succeed = status === STATUS.succeed
  const showGroups = allSizesGroups?.length > 0
  const sizes = showGroups
    ? allSizesGroups
    : allSizes?.filter(size => size.rentableType !== 'parking')
  const sizeIndex = sizes && selectedHash
    ? sizes.findIndex(size => size[showGroups ? 'warehouseSizeGroupId' : 'warehouseTypeId'] === selectedHash)
    : undefined
  const warehouseTypeId = showGroups
    ? sizes?.[sizeIndex]?.warehouseTypeIds?.[0]
    : selectedHash
  const selectedHashKeys = warehouses && warehouseTypeId
    ? Object.keys(warehouses?.[warehouseTypeId] || {})
    : undefined
  const showRentButton = selectedHashKeys && selectedHashKeys.length === 1
  const firstWarehouseKey = selectedHashKeys
    ? selectedHashKeys[0]
    : undefined
  const firstWarehouse = firstWarehouseKey
    ? warehouses[warehouseTypeId]?.[firstWarehouseKey]
    : undefined

  const wrapperRef = useRef(null)

  useEffect(() => {
    const isUnlocked = (state && typeof state === 'object' && 'unlock' in state) ? state.unlock : undefined
    if (isUnlocked) {
      replace(window.location.pathname + window.location.search)
    }
  }, [replace, state])

  useEffect(() => {
    if (selectedHash) {
      document.querySelector(`#${selectedHash}`)?.scrollIntoView({ block: 'end' })
    }
  }, [selectedHash])

  const changeHash = (toBigger = true) => {
    const newIndex = sizeIndex + (toBigger ? 1 : -1)
    const newSize = sizes[newIndex]
    if (newSize) {
      selectHash(showGroups
        ? newSize.warehouseSizeGroupId
        : newSize.warehouseTypeId)
    }
  }

  const rent = (hash, data, date) => {
    if (!config) return
    if (config?.blockedCart) {
      openPopup('blockedCart')

    } else {
      const identifier = v7()
      const id = Object.keys(data.for_rent || {})?.[0]
      const details = data?.isRental && id
        ? { id }
        : { hash }

      const body = {
        ...details,
        identifier,
        type: BASKET_TYPES.rent,
        object: data?.data?.object,
        hasOnlineAccess: data?.data?.hasOnlineAccess,
        minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
        image: data?.warehouseAnimation === 'custom' && (data?.warehouseTransparentPhoto || data?.warehousePhoto)
          ? (data.warehouseTransparentPhoto || data.warehousePhoto)
          : allSizes.find(size => size.warehouseTypeId === data?.data?.warehouseTypeId)?.renders?.default,
        rentableType: data?.rentableType,
        name: data.warehouseTypeName,
        placeId,
      }

      dispatch(addItemToBasket(body))
      push(`/order/${identifier}`)
      dispatch(extendFormToMap(false))
    }
  }

  return (
    <div className='placeResult'>
      {popup?.type === 'details' && <DetailsPopup
        count={popup.body?.count}
        data={popup.body?.details}
        rentableType={popup.body?.rentableType}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeIdParams}
        companyName={place.companyName}
        groupHash={popup.body?.groupHash}
        variantHash={popup.body?.variantHash}
        name={popup.body?.name}
      />}

      {status === STATUS.failed
        ? <Error />
        : <section className='--animated'>
          {variant
            ? <div className='placeResult__magList__wrapper'>
              <div className='placeResult__magList'>
                <h4>{t('selectAVariant')}</h4>
                {succeed
                  ? Object.entries(warehouses?.[selectedHash] || {})
                    .sort(([, a], [, b]) => a.order - b.order)
                    .map(([hash, data]) => (
                      <MagElement
                        key={hash}
                        data={data}
                        openPopup={(type) => {
                          if (type === 'details') {
                            openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count, rentableType: data?.rentableType } })
                          } else if (type === 'availability') {
                            openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: selectedHash, variantHash: hash } })
                          }
                        }}
                        action={date => {
                          rent(hash, data, date)
                        }}
                      />
                    ))
                  : [1, 2, 3].map((e) => <MagElement key={e} />)}
              </div>
            </div>
            : ((succeed && sizes) || status === STATUS.pending) && <>
              <div className='placeResult__mag'>
                {sizes && sizes.length > 1 && <div className='placeResult__buttons__wrapper'>
                  {showGroups
                    ? <div className='placeResult__buttons'>
                      {sizes.map(size => <button
                        id={size.warehouseSizeGroupId}
                        key={size.warehouseSizeGroupId}
                        className={`button placeResult__button${size.warehouseSizeGroupId === selectedHash ? ' --selected' : ''}`}
                        onClick={() => {
                          if (size.warehouseSizeGroupId === selectedHash) return
                          selectHash(size.warehouseSizeGroupId)
                        }}>
                        {size.areaMinShortName} - {size.areaMaxShortName}
                      </button>
                      )}
                    </div>
                    : <div className='placeResult__buttons'>
                      {sizes.map(size => <button
                        id={size.warehouseTypeId}
                        key={size.warehouseTypeId}
                        className={`button placeResult__button${size.warehouseTypeId === selectedHash ? ' --selected' : ''}`}
                        onClick={() => {
                          if (size.warehouseTypeId === selectedHash) return
                          selectHash(size.warehouseTypeId)
                        }}>
                        {size.sizeShortName || size.name}
                      </button>
                      )}
                    </div>}
                </div>}

                {place.constructionDate && <div className='placeResult__mag__construction'>
                  <div className='placeResult__mag__construction__left center'>
                    <i className='icon icon--front-loader' />
                    <span>{t('theYardIsUnderConstruction')}</span>
                  </div>
                  <span className='placeResult__mag__construction__right'>{t('availableFrom')} {place.constructionDate}</span>
                </div>}

                <div className='placeResult__mag__title'>
                  <h2>{sizes?.[sizeIndex]?.name}</h2>
                </div>

                <div className='placeResult__mag__graphics'>
                  {sizes.length > 1 && <div
                    className='mag__marker'
                    onClick={() => succeed && sizeIndex > 0 && changeHash(false)}
                    style={sizeIndex === 0 ? { opacity: '0.5' } : undefined}>

                    <div className='marker'>
                      <i className='icon icon--chevron-left' />
                    </div>
                    <span>{t('smaller')}</span>
                  </div>}

                  {succeed && (
                    <div className='mag__img'>
                      <img
                        alt='warehouse'
                        src={(sizes[sizeIndex]?.renders?.default || sizes[sizeIndex]?.image || htbox1)}
                      />
                    </div>
                  )}

                  {sizes.length > 1 && <div
                    className='mag__marker'
                    onClick={() => succeed && sizeIndex < sizes.length - 1 && changeHash()}
                    style={(!succeed || sizeIndex === sizes.length - 1) ? { opacity: '0.5' } : undefined}>
                    <div className='marker'>
                      <i className='icon icon--chevron-right' />
                    </div>
                    <span>{t('bigger')}</span>
                  </div>}
                </div>

                {showGroups
                  ? <div className='magElement__footer'>
                    <div className='magElement__footer__price'>
                      <span>{t('from')} {Number(firstWarehouse?.data?.monthlyGrossPrice)} zł</span>
                      <span>{t('monthly')}</span>
                    </div>
                    <ArrowBtn
                      enlarged
                      className='--black'
                      text={t('selectSize')}
                      action={() => {
                        wrapperRef.current?.scrollIntoView({ behavior: 'smooth' })
                      }}
                    />
                  </div>
                  : showRentButton
                    ? <div className='magElement__footer'>
                      <div className='magElement__footer__price'>
                        <span>{Number(firstWarehouse?.data?.monthlyGrossPrice)} zł</span>
                        <span>{t('monthly')}</span>
                      </div>
                      <RentButton
                        disabled={!firstWarehouse?.count}
                        for_rent={firstWarehouse?.for_rent}
                        isAvailableForRentNow={firstWarehouse?.isAvailableForRentNow}
                        rent={(date) => {
                          if (date) rent(firstWarehouseKey, firstWarehouse, date)
                          else rent(firstWarehouseKey, firstWarehouse)
                        }}
                        openAvailabilityPopup={() => {
                          openPopup({
                            type: 'availability',
                            body: { name: `${firstWarehouse?.warehouseTypeName} - ${firstWarehouse?.name}`, groupHash: selectedHash, variantHash: firstWarehouseKey }
                          })
                        }}
                      />
                    </div>
                    : <div className='magElement__footer'>
                      <div className='magElement__footer__price'>
                        <span>{t('from')} {Number(firstWarehouse?.data?.monthlyGrossPrice)} zł</span>
                        <span>{t('monthly')}</span>
                      </div>
                      <ArrowBtn
                        enlarged
                        text={t('selectAVariant')}
                        action={() => {
                          selectHash(selectedHash, firstWarehouseKey)
                        }}
                      />
                    </div>}
              </div>
              {showGroups
                ? <div
                  ref={wrapperRef}
                  className='placeResult__sizes'>
                  <div className='placeResult__magList__wrapper'>
                    <div className='placeResult__magList'>
                      {sizes[sizeIndex]?.fits && sizes[sizeIndex].fits.length > 0 && <>
                        <h4>{t('whatCanYouFitHere')}</h4>
                        <div className='placeResult__sizes__list'>
                          {sizes[sizeIndex].fits.map(({ name }, idx) => <div
                            key={idx}
                            className='placeResult__sizes__list__item'>
                            <i className='icon icon--checkbox'></i>
                            <span>{name}</span>
                          </div>)}
                        </div>
                      </>}
                      <div className='placeResult__magList__title --secFont'>{t('selectSize')}</div>
                      {succeed
                        ? sizes[sizeIndex]?.warehouseTypeIds?.map(id => {
                          return Object.entries(warehouses?.[id] || {})
                            .sort(([, a], [, b]) => a.order - b.order)
                            .map(([hash, data]) => (
                              <MagElement
                                key={hash}
                                data={data}
                                showSizes
                                openPopup={(type) => {
                                  if (type === 'details') {
                                    openPopup({ type: 'details', body: { details: data?.details, count: data?.free_now_to_rent_count, rentableType: data?.rentableType } })
                                  } else if (type === 'availability') {
                                    openPopup({ type: 'availability', body: { name: `${data?.warehouseTypeName} - ${data?.name}`, groupHash: selectedHash, variantHash: hash } })
                                  }
                                }}
                                action={date => {
                                  rent(hash, data, date)
                                }}
                              />
                            ))
                        })
                        : [1, 2, 3].map((e) => <MagElement key={e} />)}
                    </div>
                  </div>
                </div>
                : (({ internalHeight, internalLength, internalWidth, doorHeight, doorWidth, fits }) => {
                  return <div className='placeResult__sizes'>
                    {firstWarehouse?.details?.[1]?.list && firstWarehouse?.details?.[1]?.list.length > 0 && <>
                      <h4>{t('storageFeatures')}</h4>
                      <div className='placeResult__sizes__attributes'>
                        {firstWarehouse.details[1].list.map((item) => <div
                          key={item.id}
                          className='placeResult__sizes__attribute'>
                          <i className={`icon icon--${item.key}-bold`}></i>
                          <span>{item.name}</span>
                        </div>)}
                      </div>
                    </>}

                    {fits && fits.length > 0 && <>
                      <h4>{t('whatCanYouFitHere')}</h4>
                      <div className='placeResult__sizes__list'>
                        {fits?.map(({ name }, idx) => <div
                          key={idx}
                          className='placeResult__sizes__list__item'>
                          <i className='icon icon--checkbox'></i>
                          <span>{name}</span>
                        </div>)}
                      </div>
                    </>}

                    {(internalLength || internalWidth || internalHeight) && <>
                      <h4>{t('internalDimensions')}:</h4>
                      <div className='placeResult__sizes__dimensions'>
                        <div className='placeResult__sizes__dimension'>
                          <i className='icon icon--length' />
                          <span>{t('length-short')}: {Number(internalLength)}m</span>
                        </div>
                        <div className='placeResult__sizes__dimension'>
                          <i className='icon icon--width' />
                          <span>{t('width-short')}: {Number(internalWidth)}m</span>
                        </div>
                        <div className='placeResult__sizes__dimension'>
                          <i className='icon icon--height' />
                          <span>{t('height-short')}: {Number(internalHeight)}m</span>
                        </div>
                      </div>
                    </>}

                    {type !== 'chr01' && (doorWidth || doorHeight) && <>
                      <h4>{t('doorDimensions')}:</h4>
                      <div className='placeResult__sizes__dimensions'>
                        <div className='placeResult__sizes__dimension'>
                          <i className='icon icon--width' />
                          <span>{t('width-short')}: {Number(doorWidth)}m</span>
                        </div>
                        <div className='placeResult__sizes__dimension'>
                          <i className='icon icon--height' />
                          <span>{t('height-short')}: {Number(doorHeight)}m</span>
                        </div>
                      </div>
                    </>}
                  </div>
                })(sizes[sizeIndex] || {})}
            </>}
        </section>}
    </div>
  )
}

export default MapDetails